import { translate } from '~/functions/translate'
import { type QuestionSummaryType } from '~/types/types'
import { handleUndefined } from '../common'

export const disclosureSlideContent = (tableData: any) => {
  if (tableData)
    return [
      {
        margin: [0, 10, 0, 0],
        columns: [
          [
            {
              svg: `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 11.4297V18.2868" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15.9983 26.2857C16.6295 26.2857 17.1412 25.774 17.1412 25.1429C17.1412 24.5117 16.6295 24 15.9983 24C15.3671 24 14.8555 24.5117 14.8555 25.1429C14.8555 25.774 15.3671 26.2857 15.9983 26.2857Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M18.0329 2.39977C17.8411 2.02537 17.5497 1.71116 17.1908 1.49175C16.8319 1.27235 16.4193 1.15625 15.9987 1.15625C15.578 1.15625 15.1655 1.27235 14.8065 1.49175C14.4476 1.71116 14.1562 2.02537 13.9644 2.39977L1.39295 27.5426C1.21761 27.8906 1.13413 28.2776 1.15044 28.6669C1.16675 29.0562 1.2823 29.4348 1.48612 29.7669C1.68994 30.099 1.97527 30.3734 2.31501 30.5642C2.65474 30.755 3.0376 30.8557 3.42724 30.8569H28.5701C28.9597 30.8557 29.3426 30.755 29.6823 30.5642C30.0221 30.3734 30.3074 30.099 30.5112 29.7669C30.715 29.4348 30.8306 29.0562 30.8469 28.6669C30.8632 28.2776 30.7797 27.8906 30.6044 27.5426L18.0329 2.39977Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`,
              width: 35,
            },
          ],
          [
            {
              text: tableData.label,
              style: ['disclosure'],
            },
          ],
        ],
      },
      table(tableData),
    ]
}
const table = (tableData: any) => {
  return {
    layout: 'noBorders',
    margin: [0, 10, 0, 0],
    table: {
      widths: [260, 240, 240],
      body: [
        [
          {
            text: '',
          },
          {
            text: translate('esg.pdfExport.disclosureRisks'),
            style: ['disclosureHeader'],
          },
          {
            text: translate('esg.pdfExport.comments'),
            style: ['comments'],
          },
        ],
        ...getSubsectionRows(tableData),
      ],
    },
  }
}
const getDisclosureIcon = (
  riskLabels: any,
  trueIconMargin = 26, // 20,
  flagIconMargin = 30, // 23
) => {
  if (riskLabels && riskLabels.length)
    return {
      svg: `<svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.42522 0.414062H19.7187C20.417 0.414062 21.0455 0.837584 21.3076 1.48478C21.5698 2.13197 21.4132 2.87349 20.9117 3.35942L16.4176 7.71456L20.9117 12.0697C21.4132 12.5556 21.5698 13.2972 21.3076 13.9443C21.0455 14.5915 20.417 15.0151 19.7187 15.0151H4.13951V22.8771C4.13951 23.8239 3.372 24.5914 2.42522 24.5914C1.47845 24.5914 0.710938 23.8239 0.710938 22.8771V13.3008V2.12835C0.710938 1.18157 1.47845 0.414062 2.42522 0.414062ZM4.13951 11.5865H15.4864L12.7612 8.94563C12.428 8.62273 12.2399 8.17856 12.2399 7.71456C12.2399 7.25057 12.428 6.80639 12.7612 6.48349L15.4864 3.84263H4.13951V11.5865Z" fill="#EA5280"/>
      <path d="M21.3076 1.48478L21.0759 1.57863L21.3076 1.48478ZM20.9117 3.35942L21.0857 3.53895L20.9117 3.35942ZM16.4176 7.71456L16.2436 7.53503C16.195 7.58212 16.1676 7.64689 16.1676 7.71456C16.1676 7.78223 16.195 7.847 16.2436 7.89409L16.4176 7.71456ZM20.9117 12.0697L21.0857 11.8902L20.9117 12.0697ZM4.13951 15.0151V14.7651C4.00144 14.7651 3.88951 14.877 3.88951 15.0151H4.13951ZM4.13951 11.5865H3.88951C3.88951 11.7246 4.00144 11.8365 4.13951 11.8365V11.5865ZM15.4864 11.5865V11.8365C15.5882 11.8365 15.6799 11.7747 15.7181 11.6803C15.7563 11.586 15.7335 11.4778 15.6604 11.407L15.4864 11.5865ZM12.7612 8.94563L12.5873 9.12516L12.7612 8.94563ZM12.7612 6.48349L12.5873 6.30396V6.30396L12.7612 6.48349ZM15.4864 3.84263L15.6604 4.02217C15.7335 3.9513 15.7563 3.84316 15.7181 3.74878C15.6799 3.6544 15.5882 3.59263 15.4864 3.59263V3.84263ZM4.13951 3.84263V3.59263C4.00144 3.59263 3.88951 3.70456 3.88951 3.84263H4.13951ZM2.42522 0.664062H19.7187V0.164062H2.42522V0.664062ZM19.7187 0.664062C20.3152 0.664062 20.852 1.02582 21.0759 1.57863L21.5393 1.39092C21.239 0.649348 20.5188 0.164062 19.7187 0.164062V0.664062ZM21.0759 1.57863C21.2998 2.13144 21.1661 2.76482 20.7378 3.17989L21.0857 3.53895C21.6603 2.98215 21.8397 2.1325 21.5393 1.39092L21.0759 1.57863ZM20.7378 3.17989L16.2436 7.53503L16.5916 7.89409L21.0857 3.53895L20.7378 3.17989ZM16.2436 7.89409L20.7378 12.2492L21.0857 11.8902L16.5916 7.53503L16.2436 7.89409ZM20.7378 12.2492C21.1661 12.6643 21.2998 13.2977 21.0759 13.8505L21.5393 14.0382C21.8397 13.2966 21.6603 12.447 21.0857 11.8902L20.7378 12.2492ZM21.0759 13.8505C20.852 14.4033 20.3152 14.7651 19.7187 14.7651V15.2651C20.5188 15.2651 21.239 14.7798 21.5393 14.0382L21.0759 13.8505ZM19.7187 14.7651H4.13951V15.2651H19.7187V14.7651ZM3.88951 15.0151V22.8771H4.38951V15.0151H3.88951ZM3.88951 22.8771C3.88951 23.6858 3.23393 24.3414 2.42522 24.3414V24.8414C3.51007 24.8414 4.38951 23.962 4.38951 22.8771H3.88951ZM2.42522 24.3414C1.61652 24.3414 0.960938 23.6858 0.960938 22.8771H0.460938C0.460938 23.962 1.34038 24.8414 2.42522 24.8414V24.3414ZM0.960938 22.8771V13.3008H0.460938V22.8771H0.960938ZM0.960938 13.3008V2.12835H0.460938V13.3008H0.960938ZM0.960938 2.12835C0.960938 1.31965 1.61652 0.664062 2.42522 0.664062V0.164062C1.34038 0.164062 0.460938 1.0435 0.460938 2.12835H0.960938ZM4.13951 11.8365H15.4864V11.3365H4.13951V11.8365ZM15.6604 11.407L12.9352 8.7661L12.5873 9.12516L15.3124 11.766L15.6604 11.407ZM12.9352 8.7661C12.6506 8.49029 12.4899 8.11089 12.4899 7.71456H11.9899C11.9899 8.24622 12.2055 8.75517 12.5873 9.12516L12.9352 8.7661ZM12.4899 7.71456C12.4899 7.31823 12.6506 6.93883 12.9352 6.66302L12.5873 6.30396C12.2055 6.67395 11.9899 7.1829 11.9899 7.71456H12.4899ZM12.9352 6.66302L15.6604 4.02217L15.3124 3.6631L12.5873 6.30396L12.9352 6.66302ZM15.4864 3.59263H4.13951V4.09263H15.4864V3.59263ZM3.88951 3.84263V11.5865H4.38951V3.84263H3.88951Z" fill="#EA5280"/>
      </svg>`,
      width: 18,
      height: 18,
      margin: [0, flagIconMargin, 0, 0],
    }
  return {
    svg: `<svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.37891 14.8571L12.1144 17.6686C12.2148 17.7463 12.3322 17.802 12.4583 17.8317C12.5844 17.8613 12.7159 17.8642 12.8433 17.84C12.9719 17.8173 13.0938 17.7688 13.2007 17.6978C13.3077 17.6268 13.3971 17.535 13.4629 17.4286L19.3121 8" stroke="#17C792" stroke-width="3.42857" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.8443 24.2857C20.3858 24.2857 25.6887 19.2969 25.6887 13.1429C25.6887 6.98883 20.3858 2 13.8443 2C7.30289 2 2 6.98883 2 13.1429C2 19.2969 7.30289 24.2857 13.8443 24.2857Z" stroke="#17C792" stroke-width="3.42857" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`,
    width: 18,
    height: 18,
    margin: [0, trueIconMargin, 0, 0],
  }
}
const removeBulletFromUl = (riskLables: any, isLineBreak = true) => {
  const defaultText = { text: '\n\n', listType: 'none' }
  const disClose = {
    text: translate('general.nothingToDisclose'),
    listType: 'none',
  }
  let risks
  if (riskLables && riskLables.length) {
    risks = riskLables.map((riskLable: string) => ({
      text: riskLable,
      listType: 'none',
      width: 10,
    }))
    isLineBreak && risks.unshift(defaultText)
    return risks
  }
  risks = [disClose]
  isLineBreak && risks.unshift(defaultText)
  return risks
}

export const getSubsectionRows = (tableData: any) => {
  const result: any[] = []
  for (const value of tableData?.subsections) {
    const questionsForSubsection =
      value.questionSummaries as QuestionSummaryType[]
    if (questionsForSubsection.length >= 1) {
      const row = questionsForSubsection[0]
      result.push([
        {
          text: [
            `${row.subsectionLabel}\n\n`,
            {
              text: row.label,
              style: ['problems'],
            },
          ],
          style: ['disclosureSubHeader'],
        },
        {
          columns: [
            [getDisclosureIcon(row.disclosureRisks)],
            [
              {
                ul: removeBulletFromUl(row.disclosureRisks),
                style: ['risk'],
              },
            ],
          ],
        },
        {
          text: '\n\n' + handleUndefined(row.comment) || '',
          style: ['label'],
          margin: [0, 8, 0, 0],
        },
      ])
    }
    if (questionsForSubsection.length > 1) {
      const secondRow = questionsForSubsection[1]
      result.push([
        {
          text: [
            {
              text: secondRow.label,
              style: ['problems'],
            },
          ],
          style: ['disclosureSubHeader'],
        },
        {
          columns: [
            [getDisclosureIcon(secondRow.disclosureRisks, 0, 2)],
            [
              {
                ul: removeBulletFromUl(secondRow.disclosureRisks, false),
                style: ['risk'],
                margin: [-120, 5, 0, 0],
              },
            ],
          ],
        },
        {
          text: '\n\n' + handleUndefined(secondRow.comment) || '',
          style: ['label'],
          margin: [0, -12, 0, 0],
        },
      ])
    }
  }
  return result
}
export const disclosureStyle = {
  risk: {
    color: '#5B7185',
    fontSize: 9,
    margin: [-120, 9, 20, 0],
  },
  disclosure: {
    margin: [-340, 10, 0, 0],
    fontSize: 16,
    bold: true,
    color: '#343F49',
  },
  disclosureSubHeader: {
    color: '#5B7185',
    bold: true,
    alignment: 'left',
    fontSize: 10,
    margin: [0, 3, 20, 0],
  },
  disclosureHeader: {
    color: '#5B7185',
    bold: true,
    fontSize: 10,
    margin: [0, 0, 0, 8],
  },
  comments: {
    color: '#5B7185',
    bold: true,
    fontSize: 10,
    margin: [0, 0, 0, 8],
  },
}
